import { Store } from "lucide-react";

import { cn } from "src/lib/utils";

const hashString = (value = "") => {
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }

  return Math.abs(hash);
};

const storeAvatarPalette = [
  "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-500/30 dark:bg-sky-500/15 dark:text-sky-300",
  "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/15 dark:text-emerald-300",
  "border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-500/30 dark:bg-violet-500/15 dark:text-violet-300",
  "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/15 dark:text-amber-300",
  "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/30 dark:bg-rose-500/15 dark:text-rose-300",
  "border-teal-200 bg-teal-50 text-teal-700 dark:border-teal-500/30 dark:bg-teal-500/15 dark:text-teal-300",
  "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/30 dark:bg-indigo-500/15 dark:text-indigo-300",
  "border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700 dark:border-fuchsia-500/30 dark:bg-fuchsia-500/15 dark:text-fuchsia-300",
];

const getStoreSeedClassName = (integrationId) =>
  storeAvatarPalette[hashString(integrationId) % storeAvatarPalette.length];

const getStoreInitial = (storeName) =>
  String(storeName || "")
    .trim()
    .charAt(0)
    .toUpperCase() || "S";

export const StoreAvatar = ({
  integrationId,
  storeName,
  className,
  isDemo,
}) => (
  <div
    className={cn(
      "flex aspect-square items-center justify-center rounded-lg border font-semibold",
      isDemo
        ? "border-primary/30 bg-primary/10 text-primary"
        : getStoreSeedClassName(integrationId),
      className
    )}
    aria-hidden="true"
  >
    {isDemo ? <Store className="size-4" /> : getStoreInitial(storeName)}
  </div>
);
